import React, { useState } from 'react';
import { Button, Select, TableProps } from 'antd';
import { useMakeSelect, useModel } from '../../../../../../Hooks/TT_ELD/Makes-Models';
import ModelTable from './ModelTable';
import AddModelList from './AddModelList';
import SearchOptions from '../../../../../../Utils/SearchOptions';
import { SearchResultForModel } from '../../../../../../Utils/SearchResults';
import useRouteQuery from '../../../../../../Utils/useRouterQuery';
import { useTagQuerySync } from '../../../../../../Utils/useTagQuerySync';
import { TableParams } from '../../../../../../Utils/TableTypes';

type Data = {
  data?: {
    data: Array<any>;
    count: number;
  };
  isLoading?: boolean;
  refetch?: any;
  isFetching?: any;
};

const Model = () => {
  const [makeId, setMakeId] = useState<string>('');
  const [modelName, setModelName] = useRouteQuery('', 'modelName', (v) => String(v));
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  useTagQuerySync(
    { en_US: 'Models', zh_CN: '' },
    'models',
    { modelName, makeId, tableParams },
    { modelName: setModelName, makeId: setMakeId, tableParams: setTableParams },
  );

  const { data, isLoading, isFetching, refetch } = useModel(modelName, makeId, tableParams);

  const make: Data = useMakeSelect();

  const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };
  const handleSearchSelect =
    (setter: (val: string) => void, nameSetter?: (val: string) => void) =>
    (val: any, { valId }: { valId: string }) => {
      setter(valId);
      nameSetter?.(val);
      if (valId) {
        setModelName(val);
        setTableParams({
          pagination: {
            current: 1,
          },
        });
      }
    };

  const showModal = () => {
    setOpen(true);
  };
  const [open, setOpen] = useState(false);

  return (
    <div className="mainPage">
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {open && <AddModelList open={open} setOpen={setOpen} dataRefetch={refetch} />}
        <SearchOptions
          SearchResult={SearchResultForModel}
          onSelect={handleSearchSelect(setModelName)}
          placeholder="Search by model"
          value={modelName}
        />

        {make?.data?.data && (
          <Select
            allowClear
            style={{ width: 200 }}
            showSearch
            placeholder="Filter by make"
            optionFilterProp="children"
            value={makeId || undefined}
            onChange={(val) => {
              setMakeId(val ?? '');
              setTableParams({
                pagination: {
                  current: 1,
                },
              });
            }}
            filterOption={(input, option: any) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={make?.data?.data?.map((option) => ({
              value: option.id,
              label: option.name,
            }))}
          />
        )}
        <Button type="primary" style={{ marginLeft: 'auto' }} size={'large'} onClick={showModal}>
          Add Model
        </Button>
        <Button size={'large'} style={{ marginLeft: '15px' }} onClick={() => refetch()}>
          Refresh
        </Button>
      </span>
      <ModelTable
        model={data?.data}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refetch}
        handleTableChange={handleTableChange}
        tableParams={tableParams}
      />
    </div>
  );
};

export default Model;
